/** Material icon names aligned with duna-events-calendar getEventTypeIcon(). */
export function getEventTypeMaterialIcon(eventType: string | null | undefined): string {
  switch ((eventType ?? '').toLowerCase()) {
    case 'education':
      return 'school';
    case 'exercise':
    case 'excerceise':
      return 'fitness_center';
    case 'course':
      return 'menu_book';
    case 'activity':
      return 'event_available';
    case 'training':
      return 'sports';
    case 'meeting':
      return 'groups';
    case 'conference':
      return 'corporate_fare';
    case 'workshop':
      return 'build';
    case 'seminar':
      return 'record_voice_over';
    default:
      return 'event';
  }
}

export function getEventTypeLabelDa(eventType: string | null | undefined): string {
  switch ((eventType ?? '').toLowerCase()) {
    case 'education':
      return 'Uddannelse';
    case 'exercise':
    case 'excerceise':
      return 'Øvelse';
    case 'course':
      return 'Kursus';
    case 'activity':
      return 'Aktivitet';
    default:
      return (eventType ?? '').trim();
  }
}
